export default __webpack_public_path__ + "static/media/tosin.3ad468ce.jpg";